import { IonButton, IonCol, IonHeader, IonIcon, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import { DqText } from 'src/components/dq-text';
import { menu, close } from 'ionicons/icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectSideMenuOpen } from 'src/redux/common/selectors';
import { commonActions } from 'src/redux/common/actions';
import { useBreakpoint } from 'src/utils/helpers/platformHelpers';

interface DesktopHeaderProps {
  /**
   * The title of the header.
   */
  title: string;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ title }) => {
  const dispatch = useDispatch();
  const isLargeBreakpoint = useBreakpoint('lg');
  const isSideMenuOpen = useSelector(selectSideMenuOpen);

  const handleMenuClick = () => {
    dispatch(commonActions.toggleSideMenu());
  };

  return (
    <IonHeader>
      <IonToolbar>
        <IonTitle className="ion-no-padding">
          <IonRow class="ion-align-items-center">
            <IonCol className="ion-margin-start">
              <DqText variant="h1">{title}</DqText>
            </IonCol>
            <IonCol size="auto">
              {!isLargeBreakpoint && (
                <IonButton fill="clear" onClick={handleMenuClick} color="primary">
                  <IonIcon slot="icon-only" icon={isSideMenuOpen ? close : menu} />
                </IonButton>
              )}
            </IonCol>
          </IonRow>
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default DesktopHeader;
